<template>
    <div>
        <button @click="deleteCop" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-trash"></i>
        </button>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { storeService } from '@/common/api.service'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        methods:{
            deleteCop(){
                storeService.deleteCoupon(this.row.id)
                    .then(response => {
                        this.$router.push('/stores')
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {

                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {

                    })
            }
        }
    })
</script>

<style>

</style>